<template>
  <div class="salary-slider">
    <span class="salary-slider__label">{{ $t('application.salary') }}</span>
    <v-range-slider
      v-model="salaryRange"
      min="1"
      max="300"
      class="mt-1"
      hide-details
      :aria-label="$t('application.salary') + ' ' + salaryValueText"
      :name="fieldLabel"
      :disabled="noSalary"
    >
      <template v-slot:prepend>
        {{ formattedMinSalary }}
      </template>

      <template v-slot:append>
        {{ formattedMaxSalary }}
      </template>
    </v-range-slider>

    <div v-if="item.fieldValidationMode !== 2">
      <v-checkbox
        v-model="noSalary"
        :label="$t('application.noSalaryLabel')"
        hide-details
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      required: true
    },

    value: {
      type: String,
      required: false,
      default: ''
    }
  },

  data: () => ({
    salaryRange: [30, 50],
    noSalary: false
  }),

  computed: {
    fieldLabel() {
      let label = this.localize(this.item.label);

      // TODO: use enumeration
      if (this.item.fieldValidationMode === 2) {
        label += '*';
      }

      return label;
    },

    fieldValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    },

    unformattedMinSalary() {
      return `${this.salaryRange[0] * 1000}€`;
    },

    formattedMinSalary() {
      return `${(this.salaryRange[0] * 1000).toLocaleString()}€`;
    },

    unformattedMaxSalary() {
      return `${this.salaryRange[1] * 1000}€`;
    },

    formattedMaxSalary() {
      return `${(this.salaryRange[1] * 1000).toLocaleString()}€`;
    },

    salaryValueText() {
      if (this.noSalary) {
        return this.$t('application.noSalaryLabel');
      }

      if (this.salaryRange[0] === this.salaryRange[1]) {
        return this.unformattedMaxSalary;
      }

      return `${this.unformattedMinSalary} ${this.$t('to')} ${
        this.unformattedMaxSalary
      }`;
    },

    rules() {
      if (this.item.fieldValidationMode !== 2) {
        return [];
      }

      return [
        (value) => {
          if (!value || value.trim() === '') {
            return this.$t('validation.fieldIsMandatory');
          }

          return true;
        }
      ];
    }
  },

  watch: {
    salaryRange() {
      this.emitValue();
    },

    noSalary() {
      if (this.noSalary) {
        this.$emit('input', '');
      } else {
        this.emitValue();
      }
    }
  },

  mounted() {
    this.emitValue();
  },

  methods: {
    emitValue() {
      const minSalary = this.formattedMinSalary;
      const maxSalary = this.formattedMaxSalary;

      if (minSalary === maxSalary) {
        this.$emit('input', maxSalary);
      } else {
        this.$emit('input', `${minSalary} - ${maxSalary}`);
      }
    }
  }
};
</script>
